// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"oM-z","inlineTitle":"pM-z","sponsoredAdsWrapper":"qM-z","marketplaceRecosWrapper":"rM-z"};